import { render } from "./AllianzServerStatus.vue?vue&type=template&id=6f2c99a9&scoped=true"
import script from "./AllianzServerStatus.vue?vue&type=script&lang=js"
export * from "./AllianzServerStatus.vue?vue&type=script&lang=js"

import "./AllianzServerStatus.vue?vue&type=style&index=0&id=6f2c99a9&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2c99a9"]])

export default __exports__